import OrderRepository from "@/repositories/vns/OrderRepository";
import makeState from "@/storages/Base/State";
import makeGetters from "@/storages/Base/Getters";
import makeMutations from "@/storages/Base/Mutations";

export default {
    name: 'report',
    namespaced: true,
    state: {
        ...makeState(),
        exams:[]
    },
    getters: {
        ...makeGetters(),
        exams (state) {
            return state.exams
        }
    },
    mutations: {
        ...makeMutations(),
        setExams (state, array) {
            state.exams = array
        }
    },
    actions: {
        setPagination ({ commit, state }, obj) {
            commit('setPagination', obj)
        },
        async listAll ({ commit, state }, params) {
            commit('setLoading', true)
            await OrderRepository.listReport({...params, ...state.pagination}).then(response => {
                commit('setPagination', {
                    per_page: response.data.data.per_page,
                    page: response.data.data.current_page,
                    total: response.data.data.total
                })
                commit('setAll', response.data.data.data)
            }).catch(e => {})
            commit('setLoading', false)
        },
        setCurrent ({ commit, state }, obj) {
            commit('setCurrent', obj)
        },
        async listExams ({ commit, state }, container_id) {
            await OrderRepository.listExams({containerId: container_id}).then(response => {
                commit('setExams', response.data.data)
            })
        },
        setExams ({ commit, state }, array) {
            commit('setExams', array)
        }
    }
}
